import _ from 'lodash';
import { useState } from 'react';
import { onClaimFreeTrialByCoupon } from 'common/api/payment';
import { reactToastify, TOASTIFY_TYPES } from 'common/utils/reactToastify';
import { getQueryParam } from 'v2/common/utils/queryParams';

const ClaimFreeTrialByCouponCard = () => {
  const { availableFreeTrial, applicationDomain } = window;
  
  const paramCouponCode = getQueryParam('trialCode', '');
  const [couponCode, setCouponCode] = useState(paramCouponCode);

  if (_.isEmpty(paramCouponCode)) return null;
  if (_.isEmpty(availableFreeTrial)) return null;
  if (_.isNull(applicationDomain.id)) return null;
  if (applicationDomain.config['free_trial_by_coupon'] !== true) return null;

  const { live_quota: liveQuota, historic_quota: historicQuota, trial_days: trialDays } = availableFreeTrial;

  const onClickClaimFreeTrialBtn = () => {
    if (!couponCode.trim()) {
      reactToastify('Please enter a valid coupon code.', TOASTIFY_TYPES.ERROR);
      return;
    }

    onClaimFreeTrialByCoupon(couponCode.trim())
      .then((res) => {
        if (res.success) {
          reactToastify('Free trial claimed! Happy Trading.', TOASTIFY_TYPES.SUCCESS);
          setInterval(() => {
            window.location.reload();
          }, 3000);
        } else {
          reactToastify('Invalid Coupon to claim free trial.', TOASTIFY_TYPES.ERROR);
        }
      })
      .catch(() => {
        reactToastify('Something went wrong! Please contact support.', TOASTIFY_TYPES.ERROR);
      });
  };

  return (
    <div className="available-free-trial p-3 border rounded">
      <div className="status-info">
        <span className="font-weight-bold tx-14 d-block">
          Available {liveQuota && `${liveQuota} live runs,`} 
          {historicQuota && `${historicQuota} backtests`} free for {trialDays} days
        </span>
      </div>

      <div className="d-flex gap-4 align-items-center ml-2">
        <input
          id="couponCode"
          type="text"
          className="form-control form-control-sm flex-grow-1"
          placeholder="Enter coupon code"
          value={couponCode}
          onChange={(e) => setCouponCode(e.target.value)}
        />
        <button
          type="button"
          className="btn btn-light btn-sm w-50"
          onClick={onClickClaimFreeTrialBtn}
        >
          Claim Free Trial
        </button>
      </div>
    </div>
  );
};

export default ClaimFreeTrialByCouponCard;
